import { ETouchType } from 'types/touch-type';

import { getTouchPreview } from 'utils/api';

const HTML_STYLE_TAG = '<style>';
const PREVIEW_CSS_TO_INJECT = '* { -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } body { width: inherit !important; height: inherit !important; margin: 0; }';
const PDF_THUMBNAIL_PARAMS = '#toolbar=0&navpanes=0&scrollbar=0&page=1&view=FitH';

export interface EmailTouchPreviewData {
  type: 'email';
  touchTypeName: string;
  subject: string;
  html: string;
  thumbnailUrl: string;
  thumbnailWidth: number;
  thumbnailHeight: number;
}

export interface DocumentTouchPreviewData {
  type: 'html' | 'pdf';
  touchTypeName: string;
  data: string[];
  pdf?: string;
  thumbnailUrl: string;
  thumbnailWidth: number;
  thumbnailHeight: number;
}

export type TouchPreviewData = EmailTouchPreviewData | DocumentTouchPreviewData;

const toPreviewHtmlDataUrl = (html: string) => `data:text/html,${encodeURIComponent(html.replace(HTML_STYLE_TAG, `${HTML_STYLE_TAG}${PREVIEW_CSS_TO_INJECT}`))}`;

const getDocumentThumbnailDimensions = (touchTrigger: any) => {
  if (touchTrigger.touchType.name === ETouchType.Letter) {
    return { thumbnailWidth: 850, thumbnailHeight: 1100 };
  }

  return touchTrigger.metadata?.size === '6x11'
    ? { thumbnailWidth: 1125, thumbnailHeight: 625 }
    : { thumbnailWidth: 925, thumbnailHeight: 625 };
};

export const loadTouchPreviewData = async (touchTrigger: any): Promise<TouchPreviewData> => {
  const previewResponse = await getTouchPreview(touchTrigger._id);

  if ([ETouchType.Email, ETouchType.Voicemail].includes(touchTrigger.touchType.name)) {
    return {
      type: 'email',
      touchTypeName: touchTrigger.touchType.name,
      subject: previewResponse.subject,
      html: previewResponse.html,
      thumbnailUrl: `data:text/html,${encodeURIComponent(previewResponse.html ?? '')}`,
      thumbnailWidth: 800,
      thumbnailHeight: 1100,
    };
  }

  if (previewResponse.pdf) {
    return {
      type: 'pdf',
      touchTypeName: touchTrigger.touchType.name,
      pdf: previewResponse.pdf,
      data: [previewResponse.pdf],
      thumbnailUrl: `${previewResponse.pdf}${PDF_THUMBNAIL_PARAMS}`,
      ...getDocumentThumbnailDimensions(touchTrigger),
    };
  }

  if (touchTrigger.touchType.name === ETouchType.Letter) {
    const data = [toPreviewHtmlDataUrl(previewResponse.html[0])];

    return {
      type: 'html',
      touchTypeName: touchTrigger.touchType.name,
      data,
      thumbnailUrl: data[0],
      ...getDocumentThumbnailDimensions(touchTrigger),
    };
  }

  const data = [
    toPreviewHtmlDataUrl(previewResponse.html[0]),
    toPreviewHtmlDataUrl(previewResponse.html[1]),
  ];

  return {
    type: 'html',
    touchTypeName: touchTrigger.touchType.name,
    data,
    thumbnailUrl: data[0],
    ...getDocumentThumbnailDimensions(touchTrigger),
  };
};
